import { keepPreviousData, QueryClient } from '@tanstack/react-query'

export const PREVIOUS_SNAPSHOT_QUERY_OPTIONS = {
  placeholderData: () => undefined,
} as const

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5,
      retry: false,
      refetchOnWindowFocus: true,
      placeholderData: keepPreviousData,
      // Same rationale as mutations below: a latched-offline onlineManager
      // otherwise parks refetches as 'paused', so after a write the UI silently
      // keeps rendering pre-write state (e.g. an activated quote still showing
      // Draft with a live Activate button).
      networkMode: 'always',
    },
    mutations: {
      retry: false,
      // TanStack's onlineManager initializes to online and only flips on window
      // online/offline events — one unpaired 'offline' (VPN toggle, sleep/wake)
      // latches it offline for the rest of the session, and the default
      // networkMode then parks every mutation as pending/isPaused without ever
      // calling mutationFn: a button stuck on its spinner with zero network
      // traffic until reload. This app has no offline story, so let writes hit
      // the network and fail loudly instead.
      networkMode: 'always',
    },
  },
})
